import React from "react"
import Highcharts from "highcharts"
import HighchartsExporting from "highcharts/modules/exporting"
import HighchartsAccessibility from "highcharts/modules/accessibility"
import HighchartsReact from "highcharts-react-official"

if (typeof window !== "undefined" && typeof Highcharts === "object") {
  HighchartsExporting(Highcharts)
  HighchartsAccessibility(Highcharts)
}

const Highchart = props => (
  <HighchartsReact highcharts={Highcharts} {...props} />
)

export default Highchart
